import YellowCrown from "images/homepage/YellowCrown";
import React from "react";
import styled from "styled-components";
import PricingPlans from "./PricingPlans";
import { useTranslation } from "react-i18next";

const Container = styled.section.attrs({
    className: "container text-center",
})`
    margin-top: 140px;
    margin-bottom: 180px;
`;

const Heading = styled.h1`
    font-weight: 800;

    @media (min-width: 992px) {
        font-size: 56px;
    }
`;

const SubHeading = styled.div`
    max-width: 700px;
    margin: 0 auto;
    margin-bottom: 42px;
    font-size: 17px;

    @media (min-width: 992px) {
        font-size: 20px;
    }
`;

export default function Pricing() {
    const { t } = useTranslation();

    return (
        <Container id="pricing">
            <YellowCrown />
            <Heading>{t("EP_INDEX_PRICING_TITLE")}</Heading>
            <SubHeading>{t("EP_INDEX_PRICING_DESCRIPTION")}</SubHeading>
            <PricingPlans />
        </Container>
    );
}
